import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AdDataService {

  private adData = {
    displayad: null,
    clasifiedtxtad: null,
    clasifieddspad: null,
    adtype: null
  };

  split(arg0: string) {
    throw new Error('Method not implemented.');
  }

  getAdData() {
    let resp = null;
    switch (this.adData.adtype) {
      case 'displayad':
        resp = this.adData.displayad;
        break;
      case 'clasifieddspad':
        resp = this.adData.clasifieddspad;
        break;
      case 'clasifiedtxtad':
        resp = this.adData.clasifiedtxtad;
        break;
      default:
        break;
    }
    return resp;
  }

  setAdData(obj) {
    switch (this.adData.adtype) {
      case 'displayad':
        this.adData.displayad = obj;
        break;
      case 'clasifieddspad':
        this.adData.clasifieddspad = obj;
        break;
      case 'clasifiedtxtad':
        this.adData.clasifiedtxtad = obj;
        break;
      default:
        break;
    }
    console.log(this.adData);
  }

  setAdType(type: string) {
    this.adData.adtype = type;
    console.log(this.adData);
  }

  getAdType() {
    return this.adData.adtype;
  }

  initialize() {
    this.adData = {
      displayad: null,
      clasifiedtxtad: null,
      clasifieddspad: null,
      adtype: null
    };
  }

  constructor() { }
}
